import axios from 'axios'

const stores = {
    namespaced: true,
    state: {
        stores: [],
        search: ''
    },
    mutations: {
        SET_STORES(state, stores){
            state.stores = stores
        },
        UPDATE_SEARCH (state, search_text){
            state.search = search_text.toLowerCase()
        }
    },
    actions: {
        // Obtenemos el listado de las sucurssales
        storeRequest({ commit, rootState }){
            axios({
                method: "get",
                url: process.env.VUE_APP_CORE_HOST+"/api/store/?format=json",
                headers: {
                    "Authorization": "Bearer " + rootState.auth.loggedIn.access
                }
            }).then(response =>{
                    commit('SET_STORES', response.data)
                })
                .catch(err =>{
                    console.log(err)
                })
        },
        setFilter({ commit }, search_text){
            commit('UPDATE_SEARCH', search_text)
        }
    },
    getters: {
        allStores(state){
            return state.stores
        },
        getFilter(state){
            return state.search
        },
        // activeOffersCounter(state){
        //     return state.stores
        // },
        // inactiveOffersCounter(state){
        //     return state.stores
        // },
        singleStoreRequest(state){
            return id => state.stores.filter(store=>store.id==id)
        },
        getSelectedStore(state){
            return id => state.stores.filter(store=>store.id==id)
        }
    }
}

export default {
    stores
}